import React from 'react';
interface TitleWithChildrenProps {
  title: string;
  classes?: string;
  children: JSX.Element | string;
}

export const TitleWithChildren = ({
  title,
  classes,
  children,
}: TitleWithChildrenProps) => {
  const className = `${classes} flex text-left flex-col`;
  return (
    <div className={className}>
      <div className="pb-2 text-left text-neutral-50 md:text-md">{title}</div>
      <div className="justify-self-end pb-2 text-black md:pb-0">{children}</div>
    </div>
  );
};
